// ОБЩЕЕ ТЕЛО ДВУХ ИНСТАГРАМНЫХ АНКЕТ (владелец 01.09.2026: «в приложении три мастера»).
//
// ЗАКАЗ ВЛАДЕЛЬЦА 02.09.2026 (истина, план docs/TRIGGER-WIZARD-PLAN.md): «Подарок за
// подписку» запускается ЛЮБОЙ КОМБИНАЦИЕЙ входов Инстаграма, В ТОМ ЧИСЛЕ комментарием
// под публикацией — хоть один, хоть все пять; у каждого входа свои настройки или их
// нет. Один бот, один сценарий, без скрытых копий. Описание «все входы, КРОМЕ
// комментария, один на выбор» (31.08–01.09) НЕВЕРНО и переделывается по плану.
//
// «Кодовое слово в комментарии» и «Подарок за подписку» — ОДИН И ТОТ ЖЕ мастер: те же
// шаги, те же поля, та же собранная схема. Различие ровно одно — ЧТО ЗАПУСКАЕТ бота:
//  • у кодового слова вход жёстко один — комментарий под публикацией;
//  • у подарка — любой набор входов Инстаграма, включая комментарий (заказ 02.09;
//    в коде пока один вход радио без комментария — переделка по плану).
// Поэтому здесь живёт весь общий код, а сами анкеты (keyword-bot-ig.ts, gift-ig.ts) —
// это настройка запуска плюс имя, описание и сцена первого экрана. Копий не заводим:
// разъехавшись, они дали бы двух разных ботов на один и тот же ответ человека.
//
// ИДИОМА IG (капкан Ф0): «ожидания кнопки» НЕТ — нажатие quick reply приходит НОВЫМ
// сообщением с подписью кнопки, сценарий перезапускается, входящий текст разбирает
// развилка «Какую кнопку нажал?»; подписи кнопок обязаны попадать в слова запуска.
//
// ОДИН БОТ — ОДИН СЦЕНАРИЙ (ТЗ владельца 02.09.2026 §3.5). Механизм скрытых
// копий-«близнецов» снят целиком: узел «Старт» держит СПИСОК входов, а развилка
// «Откуда пришёл» разводит событие по веткам — комментарий получает личный ответ
// (replyPrivate), эфир тоже, директ и истории — обычное сообщение. Дальше все три
// приветствия сходятся в ОДНУ общую цепочку (проверка подписки, выдача, напоминание):
// дублировать её по веткам запрещено.
import {
  blankCondRow,
  igEventsOpen24h,
  type CatalogParam,
  type WorkflowJson,
  type WorkflowNode,
} from '@scriptera/ui/scenario';
import {
  ansBool,
  ansGift,
  ansGiftTgUrl,
  ansNum,
  ansStr,
  wfConnect,
  wfDropNodes,
  wfGotGate,
  wfInsertAfter,
  wfInsertBefore,
  wfRenameNode,
  wfSetNotes,
  wfSetOuts,
  wfSetParams,
  wizAttachNode,
  wizAttachNodeName,
  wizEntryWords,
  wizGiftFileParam,
  wizGiftKindParam,
  wizGiftTgParams,
  wizKeywordsParam,
  wizMsgRow,
  wizNodeTitle,
  wizSwitchParams,
  type TemplateWizardDef,
  type WizardGift,
  type WizardLead,
  type WizardLocale,
  type WizardPreviewMsg,
  type WizardStep,
  type WizardStepItemList,
  type WizEntryAt,
  type WizPill,
  wizFileName,
  WIZ_GIFT_KIND,
  WIZ_GIFT_LINK,
  WIZ_GIFT_TG,
  type WizardDemoScene,
  aboutStep,
  EXTRA_TEXT_SAMPLE,
  EXTRA_TEXT_TOGGLE,
} from './core';
import { botEntry, type BotEntry, type BotEntryEvent } from '@scriptera/db/bot-entries';
// ШАГ «ЧТО ЗАПУСКАЕТ» — ОДИН И ТОТ ЖЕ У ЦЕПОЧКИ, ТЕЛЕГРАМА И ИНСТАГРАМА (К18.1 п.9–10):
// строит его общий модуль, а слова вариантов «Когда запускать», поле кодовых слов и
// выбор публикаций живут ТАМ — второй копии полей у Инстаграма нет (К18.3 этап 2 п.4).
import {
  botTrigChat,
  botTrigStore,
  trigBlocked,
  trigModeOptions,
  trigWords,
  trigPostsParams,
  triggerStep,
  TRIG_EVENT_NAMES,
  TRIG_IG_EVENTS,
  TRIG_IG_FIELDS,
  wordsOfPatch,
  type TriggerStore,
} from './trigger-step';
// Приставка служебной метки «один ответ под публикацией» живёт ОДНИМ местом (И9.4):
// её ставит этот шаблон, а прячет с экранов общий детектор isServiceMark. Своей копии
// здесь не держим — разъедутся, и техническая метка вылезет клиенту в списке меток.
import { IG_MARK_PREFIXES } from '@scriptera/db/bot-chains';
import { SCENE_NO_FILE, type SceneTexts } from '@/lib/wizard-scene-texts';
import { GIFT_TEXTS, gotGateTexts } from './subscribe-check-tg';

// Имена узлов шаблона (истина — канон в bot_templates, миграция 20260805000000).
// Оба инста-шаблона собраны из одного канона: подарок заведён его копией (миграция
// 20260901120000), поэтому имена узлов у них общие.
const N = {
  start: 'Старт',
  profile: 'Профиль собеседника',
  saveContact: 'Запомнить контакт',
  btnSwitch: 'Какую кнопку нажал?',
  welcome: 'Приветствие',
  wait10: 'Подождать 10 минут',
  checkGot: 'Уже получил?',
  ifGot: 'Чек-лист уже забрал?',
  remindMsg: 'Напомнить про чек-лист',
  condSub: 'Подписан?',
  give: 'Выдать чек-лист',
  // Метка «подарок отдан» стоит в самом каноне: по ней считается цель бота и по ней же
  // напоминание обходит тех, кто уже всё забрал.
  tag: 'Метка: получил чек-лист',
  warm: 'Задержка 10 минут',
  extraMsg: 'Спросить впечатление',
  noSub: 'Попросить подписаться',
} as const;

/** Ветка сборки: комментарий отвечает ЛИЧНО одним сообщением (replyPrivate, [M6]), эфир
 *  тоже, а личка, ответ на историю, реакция и отметка — обычное сообщение директа. */
type IgBranch = 'comment' | 'live' | 'direct';

const branchOf = (e: BotEntryEvent): IgBranch =>
  e === 'comment' ? 'comment' : e === 'liveComment' ? 'live' : 'direct';

/**
 * Имена полей события (режим и слова) живут в ОБЩЕМ модуле (`trigger-step.ts`): те же
 * поля рисует страница триггера списка и форма «Кодового слова в комментарии».
 */
const FIELDS = TRIG_IG_FIELDS;

// Тексты СОБРАННОГО бота под язык кабинета (владелец 2026-08-06: «создал бота из
// английского кабинета — всё по-английски, и реплики тоже»). Здесь и заготовки полей
// анкеты, и запасные значения сборки, и подписи узлов готовой схемы. Свои, не калька
// ChatPlace; без эмодзи — правило владельца.
// ВАЖНО: язык выбирается ОДИН РАЗ, в момент создания бота, и запекается в черновик
// (wizard.locale) — смена языка кабинета потом реплики уже созданного бота не трогает.
export const IG_TXT = {
  ru: {
    welcome: 'Привет! У меня для тебя чек-лист в подарок. Подпишись на аккаунт и жми кнопку ниже.',
    welcomeBtn: 'Получить',
    noSub: 'Пока не вижу твоей подписки. Подпишись на аккаунт — и жми «Готово», я сразу всё пришлю.',
    noSubBtn: 'Готово',
    link: 'Готово, держи! Чек-лист по ссылке ниже',
    remind: 'Ты ещё тут? Чек-лист никуда не делся — жми кнопку, и я всё пришлю.',
    // Варианты публичного ответа под комментарием (Э3.3) — по фразе на строку: бот берёт
    // случайную, одинаковые ответы под всеми комментариями Instagram считает спамом.
    // Пять заготовок (владелец 2026-08-06: «подряд идут пять инпутов, где можно вбить
    // разные ответы»); лишние человек удаляет, недостающие добавляет.
    //
    // ПОЛ (О5.4): под комментарием бот отвечает ОТ ЛИЦА хозяина аккаунта, но эти пять
    // строк человек ВИДИТ и правит в поле анкеты — метку `{{g:жен|муж|нейтр}}` в такое
    // место ставить нельзя, она попала бы прямо в поле ввода. Поэтому заготовки написаны
    // без пола (нейтральная форма «мы»), а сам механизм пола работает там, где текст
    // человек не пишет, — в каноне шаблона (bot_templates.workflow_json).
    replies: [
      'Ответили в личку!',
      'Отправили в директ, проверяй',
      'Уже в сообщениях, лови',
      'Всё ушло тебе в личные сообщения',
      'Заглядывай в директ, там всё',
    ].join('\n'),
    // Кнопка со ссылкой внутри сообщения и заглушка вместо неотвеченного адреса.
    openBtn: 'Открыть',
    linkStub: '[ссылка]',
    // Подписи выходов развилки входящего и её заметка (человек видит их в схеме бота).
    outEntry: 'Кодовое слово',
    outOther: 'Любое другое сообщение',
    noteSwitch:
      'Что пришло от пользователя: кодовое слово начинает разговор с приветствия, ' +
      'нажатие кнопки и любое другое сообщение — повторная проверка подписки. ' +
      'Кнопки Инстаграм рисует только в приложении: с компьютера пользователь отвечает словами, ' +
      'и без этого он застрял бы на просьбе подписаться',
    // Подписи узлов собранной схемы (их человек видит в схеме бота).
    nWelcome: 'Приветствие',
    nNoSub: 'Если нет подписки',
    nGive: 'Сообщение со ссылкой',
    nRemind: 'Напоминание',
    nDelay: 'Задержка',
    nDelayMin: (m: number) => `Задержка ${m} мин`,
    nExtra: 'Дополнительное сообщение',
    nPhoto: 'Картинка к приветствию',
    // Ветка комментария: подписи узлов, заметки и метка контакта.
    tCheck: 'Уже отвечали под постом?',
    tIf: 'Ответ уже был?',
    tPub: 'Ответ под комментарием',
    tTag: 'Метка: ответили под постом',
    tagPrefix: IG_MARK_PREFIXES[0],
    // Развилка входов и приветствия веток.
    nRouter: 'Откуда пришёл',
    nRouterAny: 'Откуда пришёл (без слова)',
    noteRouterAny:
      'Слова в сообщении нет: входы без кодового слова (комментарий «любое», реакция, отметка, история) всё равно ведут к приветствию; прочий текст — на проверку подписки',
    outComment: 'Комментарий',
    outLive: 'Прямой эфир',
    outDirect: 'Личные сообщения',
    wComment: 'Приветствие (комментарий)',
    wLive: 'Приветствие (эфир)',
    noteRouter:
      'Откуда пришёл пользователь: под публикацией и в эфире Инстаграм разрешает ответить ему ровно одним личным сообщением, в личные сообщения бот пишет как обычно',
    noteWelcomePrivate:
      'Личный ответ на комментарий: Инстаграм разрешает ровно одно сообщение — переписку откроет нажатие кнопки в нём',
    noteWelcomeLive:
      'Личный ответ зрителю эфира: Инстаграм разрешает ровно одно сообщение, и только пока идёт трансляция',
    noteCheck: 'Смотрим метку в «Контактах»: под одной публикацией одному пользователю отвечаем один раз',
    // Подвал поля картинки у бота без входа-директа: Инстаграм такому человеку картинку
    // отдельным сообщением не отдаст, и картинки в схеме не будет вовсе.
    hintPhotoNoDirect:
      'Под комментарием и в эфире Инстаграм картинку не даёт: она уйдёт только тем, кто написал в личные сообщения или ответил на историю',
    notePub:
      'Публичный ответ от имени аккаунта: бот берёт случайную фразу из вариантов — одинаковые ответы Инстаграм считает спамом',
    noteTag: 'Метка в карточке пользователя: под этой публикацией ему уже ответили',
    // ОТБОР ПУБЛИЧНОГО ОТВЕТА ПО СЛОВУ (Л5.1 п.2, владелец 09.09.2026: «в личку я хочу
    // всем, а публично под комментарием — только тем, кто написал слово»). Развилка
    // стоит ПЕРВОЙ в ветке комментария: не совпало — ни публичного ответа, ни метки.
    tWords: 'Слово в комментарии?',
    noteWords:
      'Публично отвечаем только на комментарии с кодовым словом: остальным бот всё равно пишет в личные сообщения, но под комментарием молчит',
    outWords: 'Слово есть',
    outNoWords: 'Слова нет',
  },
  en: {
    welcome: 'Hi! I have a free checklist for you. Follow the account and tap the button below.',
    welcomeBtn: 'Get it',
    noSub: 'I do not see your follow yet. Follow the account, tap “Done” and I will send everything right away.',
    noSubBtn: 'Done',
    link: 'Here you go! The checklist is at the link below',
    remind: 'Still there? The checklist has not gone anywhere — tap the button and I will send it.',
    replies: [
      'Replied in your messages!',
      'Sent it to your direct, take a look',
      'It is already in your messages',
      'Everything went to your private messages',
      'Check your direct, it is all there',
    ].join('\n'),
    openBtn: 'Open',
    linkStub: '[link]',
    outEntry: 'Code word',
    outOther: 'Any other message',
    noteSwitch:
      'What the user sent: the code word starts the conversation with the welcome message, ' +
      'a button tap and any other message go to a fresh subscription check. ' +
      'Instagram only draws buttons inside the app: from a computer the user answers with words, ' +
      'and without this they would be stuck on the request to follow',
    nWelcome: 'Welcome',
    nNoSub: 'If not subscribed',
    nGive: 'Message with the link',
    nRemind: 'Reminder',
    nDelay: 'Delay',
    nDelayMin: (m: number) => `Delay ${m} min`,
    nExtra: 'Follow-up message',
    nPhoto: 'Welcome image',
    tCheck: 'Already replied under this post?',
    tIf: 'Was there a reply?',
    tPub: 'Reply under the comment',
    tTag: 'Tag: replied under the post',
    tagPrefix: IG_MARK_PREFIXES[1],
    nRouter: 'Where they came from',
    nRouterAny: 'Where they came from (no code word)',
    noteRouterAny:
      'No code word in the message: entries without a code word (comment “any”, reaction, mention, story) still lead to the welcome; other text goes to the subscription check',
    outComment: 'Comment',
    outLive: 'Live broadcast',
    outDirect: 'Direct messages',
    wComment: 'Welcome (comment)',
    wLive: 'Welcome (live)',
    noteRouter:
      'Where the user came from: under a post and in a live Instagram allows exactly one private message in reply, while in direct messages the bot writes as usual',
    noteWelcomePrivate:
      'Private reply to the comment: Instagram allows exactly one message — the chat opens when the user taps the button inside it',
    noteWelcomeLive:
      'Private reply to a live viewer: Instagram allows exactly one message, and only while the stream is on',
    noteCheck: 'We look at the tag in “Contacts”: under one post each user gets one public reply',
    hintPhotoNoDirect:
      'Instagram does not allow an image under a comment or in a live: it goes only to those who wrote in DMs or replied to a story',
    notePub:
      'Public reply from the account: the bot picks a random phrase from the variants — identical replies are treated as spam by Instagram',
    noteTag: 'Tag on the user card: they have already been answered under this post',
    tWords: 'Code word in the comment?',
    noteWords:
      'The public reply goes only to comments with the code word: everyone else still gets a private message, but nothing under their comment',
    outWords: 'Word matched',
    outNoWords: 'No word',
  },
} as const satisfies Record<WizardLocale, Record<string, unknown>>;

const SENDER = "={{ $('Старт').first().json.senderId }}";

/** Где у Инстаграма лежит текст входящего (нажатие кнопки приходит НОВЫМ сообщением с
 *  подписью кнопки — идиома IG, см. шапку файла). */
const AT: WizEntryAt = { startName: N.start, channel: 'instagram' };

/** Кнопки ВНУТРИ пузыря (вид ChatPlace, IG-MESSAGE-LOOK Э1): «действие» — нажатие
 *  приходит новым событием с текстом = подписи, развилки по подписи работают как с
 *  быстрыми ответами. Бледные чипы quick_replies мастер больше не ставит. */
function bubble(...titles: string[]) {
  return { buttons: { button: titles.map((t) => ({ title: t, kind: 'action', payload: t })) } };
}

/** Пилюля развилки «Откуда пришёл»: сравнение с входом, который сработал (§3.5). Читаем
 *  поле у САМОГО «Старта» — между ним и развилкой стоят шаги контакта, и `$json` там уже
 *  их. Ряд «своё условие» — карточка кабинета покажет формулу как есть. */
function eventPill(branch: IgBranch, label: string): WizPill {
  const events = ALL_EVENTS.filter((e) => branchOf(e) === branch);
  return {
    outputKey: label,
    group: {
      rows: events.map((e, i) => ({
        ...blankCondRow('raw', `sw-ev-${branch}-${i}`),
        expr: `$('${N.start}').first().json.event === '${e}'`,
      })),
      any: true,
    },
  };
}

/** Та же пилюля по ЯВНОМУ списку событий — для развилки «Откуда пришёл (без слова)»:
 *  туда ведут только входы без кодового слова, и событие входа со словом сюда не входит. */
function eventsPill(events: readonly BotEntryEvent[], label: string, idPrefix: string): WizPill {
  return {
    outputKey: label,
    group: {
      rows: events.map((e, i) => ({
        ...blankCondRow('raw', `${idPrefix}-${i}`),
        expr: `$('${N.start}').first().json.event === '${e}'`,
      })),
      any: true,
    },
  };
}

/** Пилюля развилки «Какую кнопку нажал?»: входящий текст равен подписи кнопки (без учёта
 *  регистра — человек может набрать слово руками). Условие — ряд «Текст сообщения» языка
 *  конструктора: карточка открывается человеческими словами и правится. */
function btnPill(id: string, btn: string): WizPill {
  return { outputKey: btn, group: { rows: [wizMsgRow(id, AT, btn)], any: false } };
}

/** Настройка запуска — единственное, чем анкеты отличаются друг от друга. */
export interface IgWizardCfg {
  id: string;
  templateSource: string;
  demoScene: WizardDemoScene;
  lead: (locale: WizardLocale) => WizardLead;
  /** Короткое имя для предзаполнения «О боте» («Кодовое слово»); нет — заголовок lead. */
  shortTitle?: (locale: WizardLocale) => string;
  /**
   * ВХОДЫ ЖЁСТКИЕ: анкета их не спрашивает, они заданы здесь («Кодовое слово в
   * комментарии» — только комментарий, владелец 02.09). Не задано — входы отмечает
   * человек галочками (`entryEvents`, мастер «Подарок за подписку»).
   */
  fixedEvents?: readonly BotEntryEvent[];
}

/** Кому уходит ПУБЛИЧНЫЙ ответ под комментарием (Л5.1 п.2): всем, со словом, ровно словом. */
export type IgReplyMode = 'all' | 'keyword' | 'exact';

/** Имена ответов отбора публичного ответа — одни у шага, страницы и сборки. */
export const IG_REPLY_MODE_FIELD = 'commentReplyMode';
export const IG_REPLY_WORDS_FIELD = 'commentReplyWords';

/** Настройка ОДНОГО входа: чувствительность, слова и публикации (только у комментария). */
export interface IgEntrySetting {
  kind: 'any' | 'keyword' | 'exact';
  keywords: string[];
  mediaIds: string[];
}

export interface IgAnswers {
  /** Входы бота в порядке свода §3.1 (ровно то, что человек отметил). */
  events: BotEntryEvent[];
  /** Настройка каждого входа. */
  entry: Record<string, IgEntrySetting>;
  /** Публикации для входа-комментария: 'all' — любые, 'some' — только выбранные. */
  postsMode: string;
  /** Выбранные публикации (id Меты, только цифры) — фильтр входа-комментария. */
  mediaIds: string[];
  checkSub: boolean;
  /** Сводная чувствительность (первый вход со словами) — ею собирается развилка входящего. */
  startMode: string;
  keywords: string[];
  exactMatch: boolean;
  welcomeText: string;
  welcomeBtn: string;
  welcomeImage: string;
  noSubText: string;
  noSubBtn: string;
  linkText: string;
  /** Подпись кнопки со ссылкой (Инстаграм умеет любой текст кнопки — Л1 п.9). */
  linkBtn: string;
  linkUrl: string;
  /** Что уходит вместе с сообщением: ссылка (как было) или ОДНО вложение с файлом. */
  gift: WizardGift;
  /** Отвечать публично под комментарием (Э3); фразы — по строке, случайная на отправке. */
  commentReply: boolean;
  commentTexts: string[];
  /**
   * КОМУ БОТ ОТВЕЧАЕТ ПУБЛИЧНО, когда его запускает ЛЮБОЙ комментарий (Л5.1 п.2, владелец
   * 09.09.2026: «я пишу „напиши ОТНОШЕНИЯ“; кто-то пишет „отношения“, а кто-то — просто
   * мнение. В личку я хочу всем, а публично под комментарием — только тем, кто написал
   * слово. Иначе выглядит тупо»). Личное сообщение уходит всем и всегда — отбор касается
   * ТОЛЬКО публичного ответа под комментарием.
   *
   * Действует, лишь пока вход-комментарий стоит «любой»: при входе со словом бот и так
   * запускается только от него, и второй такой же отбор был бы обманом. Ответы из базы
   * при этом не чистятся — сменил вход обратно, и отбор снова в силе (Л5.3).
   */
  commentReplyMode: IgReplyMode;
  commentReplyWords: string[];
  /** ВСЕГДА false (владелец 08.09.2026, Л1 п.9): поведение одно — ОДИН публичный ответ
   *  человеку под постом. Поля в анкете нет, старый ответ `true` из базы читается как
   *  `false`; само поле оставлено, чтобы правило было видно прямо в разборе ответов. */
  commentEvery: boolean;
  remind: boolean;
  remindText: string;
  extra: boolean;
  extraText: string;
  extraMinutes: number;
  /** Через сколько часов молчания бот отпускает человека (замок диалога, Л1 п.5). */
  finishHours: number;
  /** «Не запускать повторно» (Л5.1 п.1) и срок запрета в ДНЯХ. */
  noRepeat: boolean;
  noRepeatDays: number;
}

const ALL_EVENTS = TRIG_IG_EVENTS;

/** Слова из ответа-строки «через запятую» (формат ответов анкеты — прежний). */
function wordsOf(raw: string): string[] {
  return raw
    .split(',')
    .map((x) => x.trim())
    .filter(Boolean);
}

/** id публикаций Меты из плоского ответа: только цифры, кап 50 (как у листа «Старта»). */
function mediaOf(a: Record<string, unknown>): string[] {
  return ansStr(a, 'mediaIds', 2000)
    .split(',')
    .map((x) => x.trim())
    .filter((x) => /^[0-9]+$/.test(x))
    .slice(0, 50);
}

/** Один триггер из ПЛОСКИХ ответов события (форма «Кодового слова», старый черновик). */
function flatEntry(a: Record<string, unknown>, ev: BotEntryEvent): BotEntry {
  const f = FIELDS[ev];
  // У «Реакции на историю» и «Отметки в истории» отбора по словам нет вовсе — у них
  // всегда «любое», что бы ни осталось в ответах.
  if (!f) return botEntry(ev, 'any');
  const raw = ansStr(a, f.mode, 16, 'keyword');
  const words = wordsOf(ansStr(a, f.words, 300));
  const mode = raw === 'any' ? 'any' : raw === 'exact' ? 'exact' : 'keyword';
  // Слов нет — «содержит слово» молча глушил бы бота: считаем такой вход любым.
  const kind = mode === 'any' || words.length === 0 ? 'any' : mode;
  return botEntry(ev, kind, {
    keywords: kind === 'any' ? [] : words,
    mediaIds: ev === 'comment' && ansStr(a, 'postsMode', 8, 'all') === 'some' ? mediaOf(a) : [],
  });
}

/**
 * СТАРЫЙ ЧЕРНОВИК ИНСТАГРАМА → СПИСОК ТРИГГЕРОВ (К18.3 этап 2 п.4). До 06.09 входы жили
 * набором галочек `entryEvents` и плоскими полями каждого события
 * (`commentMode`/`commentWords`/`liveMode`/…); такие черновики лежат в базе и обязаны
 * открываться без потерь. Назад пишется только `entries`.
 *
 * Пусто — личка: «Старт» без входа не запускается никогда, а молча мёртвый бот хуже
 * неверного умолчания (правило прежнее).
 */
function igLegacyEntries(a: Record<string, unknown>): BotEntry[] {
  // НОВЫЙ ЧЕРНОВИК РОЖДАЕТСЯ БЕЗ ТРИГГЕРА (К19.1 п.8, владелец 06.09.2026: «в „Подарке
  // за подписку“ что в инсте, что в телеге по умолчанию стоит — давай уберём»): ключа
  // `entryEvents` в ответах нет вовсе — списка тоже нет, человек добавляет сам. У
  // СТАРОГО черновика ключ есть, и пустой набор галочек по-прежнему читается как
  // «Сообщение в директ» (молча мёртвый бот хуже разумного умолчания).
  const raw = a.entryEvents;
  if (raw === undefined) return [];
  const picked = Array.isArray(raw) ? raw.filter((v): v is string => typeof v === 'string') : [];
  const events = ALL_EVENTS.filter((e) => picked.includes(e));
  return (events.length > 0 ? events : (['message'] as const)).map((e) => flatEntry(a, e));
}

/** Список триггеров анкеты «Подарок за подписку» (Instagram): ответ `entries`. */
const igStore: TriggerStore<BotEntry> = botTrigStore('ig', igLegacyEntries);

/**
 * ТРИГГЕРЫ ИЗ ОТВЕТОВ АНКЕТЫ (ТЗ 02.09 §3.1). Вход жёсткий — из настройки мастера по
 * плоским полям формы; иначе — СПИСОК ТРИГГЕРОВ (К18.1 п.9), а старый черновик
 * раскладывает адаптер.
 */
function pickedEntries(a: Record<string, unknown>, cfg: IgWizardCfg): BotEntry[] {
  if (cfg.fixedEvents) {
    return ALL_EVENTS.filter((e) => cfg.fixedEvents!.includes(e)).map((e) => flatEntry(a, e));
  }
  return igStore.read(a);
}

export function readIgAnswers(
  a: Record<string, unknown>,
  locale: WizardLocale,
  cfg: IgWizardCfg,
): IgAnswers {
  const T = IG_TXT[locale];
  const extraText = ansStr(a, 'extraText', 500);
  const list = pickedEntries(a, cfg);
  const events = list.map((e) => e.event);
  const comment = list.find((e) => e.event === 'comment');
  // Режим публикаций — плоский ответ (он же у формы «Кодового слова»); нет его — судим
  // по самому триггеру.
  const flatPosts = ansStr(a, 'postsMode', 8, '');
  const postsMode =
    flatPosts === 'all' || flatPosts === 'some' ? flatPosts : (comment?.mediaIds.length ?? 0) > 0 ? 'some' : 'all';
  const mediaIds = comment ? [...comment.mediaIds] : [];
  const entry: Record<string, IgEntrySetting> = {};
  for (const e of list) {
    entry[e.event] = {
      kind: e.kind === 'exact' ? 'exact' : e.kind === 'keyword' ? 'keyword' : 'any',
      keywords: [...e.keywords],
      mediaIds: [...e.mediaIds],
    };
  }
  // Сводная чувствительность — по ПЕРВОМУ входу со словами: ею собирается развилка
  // входящего («кодовое слово» против нажатия кнопки), одна на весь сценарий.
  const lead = events.map((e) => entry[e]!).find((v) => v.kind !== 'any') ?? null;
  // Отбор публичного ответа: он есть только у входа-комментария «любой» (Л5.1 п.2).
  const rawReplyMode = ansStr(a, IG_REPLY_MODE_FIELD, 16, 'all');
  const replyMode: IgReplyMode =
    rawReplyMode === 'exact' ? 'exact' : rawReplyMode === 'keyword' ? 'keyword' : 'all';
  const replyFilterOn = (entry.comment?.kind ?? 'any') === 'any';
  const replyWords = wordsOf(ansStr(a, IG_REPLY_WORDS_FIELD, 300));
  return {
    events,
    entry,
    postsMode,
    mediaIds,
    checkSub: ansBool(a, 'checkSub', true),
    // 'exact' — тот же режим кодовых слов, только точным совпадением: остальной сборке
    // достаточно 'keyword' (точность живёт отдельным полем exactMatch ниже).
    startMode: lead ? 'keyword' : 'any',
    keywords: lead ? lead.keywords : [],
    exactMatch: lead?.kind === 'exact',
    welcomeText: ansStr(a, 'welcomeText', 500, T.welcome),
    welcomeBtn: ansStr(a, 'welcomeBtn', 20, T.welcomeBtn),
    welcomeImage: ansStr(a, 'welcomeImage', 500),
    noSubText: ansStr(a, 'noSubText', 500, T.noSub),
    noSubBtn: ansStr(a, 'noSubBtn', 20, T.noSubBtn),
    linkText: ansStr(a, 'linkText', 500, T.link),
    // Пусто (старый черновик поля не знает) — прежняя кнопка «Открыть».
    linkBtn: ansStr(a, 'linkBtn', 64, T.openBtn),
    // «ССЫЛКА В TELEGRAM-БОТ» (UT 14.10.2026 п.6) уходит той же кнопкой, что «Ссылка»:
    // адрес — готовая проверенная ссылка t.me/<логин>?start=<метка> (считает страница
    // мастера); прежний ответ «Ссылка» при этом виде не читается.
    linkUrl:
      ansStr(a, WIZ_GIFT_KIND, 8) === WIZ_GIFT_TG ? ansGiftTgUrl(a) : ansStr(a, 'linkUrl', 500),
    gift: ansGift(a, 'instagram'),
    commentReply: ansBool(a, 'commentReply', true),
    commentTexts: ansStr(a, 'commentTexts', 1000, T.replies)
      .split('\n')
      .map((s) => s.trim())
      .filter(Boolean)
      .slice(0, 20),
    // ОТБОР ПУБЛИЧНОГО ОТВЕТА ЖИВЁТ ТОЛЬКО ПРИ ВХОДЕ «ЛЮБОЙ КОММЕНТАРИЙ» (Л5.1 п.2):
    // вход со словом сам по себе фильтр, и второй такой же тут не нужен. Ответ в базе
    // остаётся как был — правда о нём одна и считается здесь, чтобы схема, экран шага и
    // превью не разошлись.
    commentReplyMode: replyFilterOn ? replyMode : 'all',
    commentReplyWords: replyWords,
    // «Отвечать каждый раз» УБРАНО (Л1 п.9): ответа из базы не читаем вовсе.
    commentEvery: false,
    // НАПОМИНАНИЕ ТОЛЬКО ТАМ, ГДЕ ЕСТЬ ОКНО (владелец 05.09.2026, CHAT-LOOK-PLAN 14.3):
    // у бота, которого запускают одни комментарии, шаг «через 10 минут» не доставится
    // никогда — в схему он и не попадает (buildIgWorkflow выбрасывает узлы по этому же
    // ответу). Ответ анкеты остаётся как был: сменил входы — напоминание ожило.
    remind: ansBool(a, 'remind') && igEventsOpen24h(events),
    remindText: ansStr(a, 'remindText', 500, T.remind),
    // Пустое доп. сообщение = выключено (как невключённый тумблер).
    extra: ansBool(a, 'extra') && extraText !== '',
    extraText,
    extraMinutes: ansNum(a, 'extraMinutes', { min: 1, max: 10080, fallback: 10 }),
    finishHours: ansNum(a, 'finishHours', { min: 1, max: 720, fallback: 24 }),
    noRepeat: ansBool(a, 'noRepeat'),
    noRepeatDays: ansNum(a, 'noRepeatDays', { min: 1, max: 365, fallback: 30 }),
  };
}

// ── Шаги анкеты ───────────────────────────────────────────────────────────────────────
//
// ОДИН ШАГ = ОДИН ВОПРОС (владелец 2026-08-10): чей аккаунт → что запускает → какое
// сообщение → приветствие → если нет подписки → что отдаём → дополнительные настройки.
// Шаг, у которого все поля скрыты, панель пропускает сама (фильтр visibleParams).

function accountStep(locale: WizardLocale): WizardStep {
  const ru = locale === 'ru';
  return {
    key: 'account',
    title: ru ? 'Аккаунт' : 'Account',
    // Что вообще делает бот, человек прочитал на шаге «Знакомство» (ТЗ-2 З1): туда
    // это описание и переехало. Здесь — только про сам аккаунт.
    intro: ru
      ? 'Выберите аккаунт Instagram, в котором будет работать бот, и укажите, требуется ли подписка.'
      : 'Select the Instagram account for the bot and specify whether a follow is required.',
    params: [
      // Аккаунт — свой блок «Аккаунт» без подсказки (владелец 05.08 №3: «мусор,
      // лишняя информация»).
      {
        name: 'accountId',
        type: 'options',
        required: true,
        default: '',
        displayName: ru ? 'Аккаунт Instagram' : 'Instagram account',
        options: [],
      },
      {
        name: 'checkSub',
        type: 'boolean',
        required: true,
        default: true,
        displayName: ru ? 'Проверить подписку' : 'Require subscription',
        description: ru
          ? 'Бот отправит материал только подписчикам аккаунта'
          : 'The bot sends the material only to followers of the account',
      },
    ],
  };
}

/** Названия и подсказки ТРИГГЕРОВ — из ОБЩЕГО свода (trigger-step.ts): те же слова
 *  стоят в меню «Добавить триггер», в строках списка и на чипах карточки бота. */
export const ENTRY_NAMES = TRIG_EVENT_NAMES;

/**
 * ШАГ «ЧТО ЗАПУСКАЕТ». Две дороги — по настройке анкеты:
 *
 *  • ВХОД ЖЁСТКИЙ («Кодовое слово в комментарии», `fixedEvents`) — обычная ФОРМА, как
 *    была: один зашитый триггер, списка ему не даём (владелец 06.09.2026 просил
 *    посмотреть; Фейбл по коду: список из одного неудаляемого элемента — лишний шаг).
 *    Правится в нём одно: слова вариантов «Когда запускать» теперь по СОБЫТИЮ («Любой
 *    комментарий», а не «Любое сообщение»), а поле кодовых слов и выбор публикаций —
 *    те же параметры, что на страницах триггеров (К18.3 этап 2 п.4 а, б).
 *  • ВХОДЫ ВЫБИРАЕТ ЧЕЛОВЕК («Подарок за подписку») — СПИСОК ТРИГГЕРОВ, ровно тот же,
 *    что у цепочки и у ботов Телеграма (К18.1 п.9): виды меню — события Инстаграма,
 *    настройка каждого открывается своей страницей, каждое событие один раз.
 */
function entryStep(locale: WizardLocale, cfg: IgWizardCfg): WizardStep {
  const ru = locale === 'ru';
  if (cfg.fixedEvents) {
    // ВХОД ЖЁСТКИЙ, значит спрашивать «откуда придёт человек» нечего — на шаге стоят
    // только настройки этого входа: чувствительность, кодовые слова и публикации
    // (ТЗ 02.09 §4). Отдельного шага «Какое сообщение» у такой анкеты нет: один вход —
    // один вопрос, и разводить его по двум экранам незачем.
    const words: CatalogParam[] = cfg.fixedEvents.flatMap((ev) => {
      const f = FIELDS[ev];
      if (!f) return [];
      return [
        {
          name: f.mode,
          type: 'options',
          required: true,
          default: 'keyword',
          displayName: ru ? 'Когда запускать' : 'When to start',
          // СЛОВА ВАРИАНТОВ — ПО СОБЫТИЮ (К18.3 этап 2 п.4 а): у комментария «Любой
          // комментарий», а не «Любое сообщение». Свод общий с триггерами.
          options: trigModeOptions(locale, ev),
        },
        // Поле кодовых слов — ТОТ ЖЕ параметр, что на странице триггера (второй копии нет).
        { ...wizKeywordsParam(locale, { [f.mode]: ['keyword', 'exact'] }, f.words), required: true },
      ];
    });
    return {
      key: 'entry',
      title: ru ? 'Что запускает' : 'What starts it',
      intro: ru
        ? 'Бот запускается комментарием под публикацией: пользователь пишет кодовое слово, бот отвечает ему в личных сообщениях.'
        : 'The bot starts from a comment under a post: the user writes the code word and the bot replies in direct messages.',
      // Выбор публикаций — тоже общий (trigPostsParams): «Под всеми» / «Только под
      // выбранными» плюс лист с фотографиями, который рисует панель.
      params: [...words, ...(cfg.fixedEvents.includes('comment') ? trigPostsParams(locale) : [])],
      // Шаг запуска: сверка занятости на «Далее» и возврат сюда по «Поменять запуск» (П160).
      starts: true,
    };
  }
  return triggerStep<BotEntry>(locale, {
    kinds: 'ig',
    key: 'entry',
    title: ru ? 'Что запускает' : 'What starts it',
    // ПОДВОДКА БЕЗ СЛОВА «ТРИГГЕР» (ТЗ USERTEST-1014 п.4, владелец 14.10.2026): примеры — из меню «Добавить» мастера.
    intro: ru
      ? 'Укажите, с чего бот начинает работу: пользователь написал в директ, оставил комментарий под публикацией или ответил на историю. Можно добавить несколько вариантов — бот запустится по любому из них.'
      : 'Specify what makes the bot start: the user wrote in direct messages, left a comment under a post or replied to a story. You can add several options — the bot starts on any of them.',
    store: igStore,
    chat: botTrigChat,
  });
}

/**
 * ШАГИ СООБЩЕНИЙ. `events` — триггеры бота (null = полный набор анкеты): по ним поле
 * картинки получает подвал-оговорку. Картинка отдельным сообщением уходит только тому,
 * с кем у Меты открыта переписка, — у бота без входа-директа её в схеме нет вовсе
 * (К27.1 п.5), и человек обязан узнать это прямо под полем, а не из молчания бота.
 */
function messageSteps(locale: WizardLocale, events: readonly BotEntryEvent[] | null): WizardStep[] {
  const ru = locale === 'ru';
  const T = IG_TXT[locale];
  const noDirect = events !== null && !events.some((e) => branchOf(e) === 'direct');
  return [
    {
      key: 'welcome',
      title: ru ? 'Приветствие' : 'Welcome',
      intro: ru
        ? 'Первое сообщение бота и кнопка, по которой пользователь получит обещанный материал.'
        : 'The first message from the bot and the button the user taps to receive the promised material.',
      params: [
        {
          name: 'welcomeText',
          type: 'string',
          required: true,
          default: T.welcome,
          typeOptions: { rows: 3 },
          displayName: ru ? 'Приветственное сообщение' : 'Welcome message',
          placeholder: ru ? 'Напишите сообщение' : 'Write a message',
        },
        {
          name: 'welcomeBtn',
          type: 'string',
          required: true,
          default: T.welcomeBtn,
          displayName: ru ? 'Текст в кнопке' : 'Button text',
          placeholder: ru ? 'Текст в кнопке' : 'Button text',
        },
        // Картинка ЗАГРУЖАЕТСЯ файлом (владелец 2026-08-06): панель рисует своим
        // контролом, который кладёт файл в публичный бакет и записывает сюда его адрес.
        {
          // ЕДИНСТВЕННОЕ ПОЛЕ АНКЕТ, КОТОРОЕ МОЖНО ПРОПУСТИТЬ (владелец 08.09.2026, Л1
          // п.8): у всех остальных стоит `required`. Слова «необязательно» в подписи
          // больше нет — само понятие из словаря убрано, чтобы хвост подписи исчез и в
          // уже установленных сборках приложения (натив берёт слово у веба).
          name: 'welcomeImage',
          type: 'string',
          default: '',
          displayName: ru ? 'Картинка к приветствию' : 'Welcome image',
          ...(noDirect ? { description: T.hintPhotoNoDirect } : {}),
        },
      ],
    },
    {
      key: 'nosub',
      title: ru ? 'Если нет подписки' : 'If not subscribed',
      // Эталон подводки (владелец 2026-08-20, CABINET-UX-FIXLIST п.7): шаг называет
      // ЖИВУЮ развилку — «нажал кнопку, а подписки нет», — а не «настройте параметры».
      intro: ru
        ? 'Это сообщение получит пользователь, который нажал кнопку, но не подписан на аккаунт.'
        : 'This message is shown to a user who tapped the button but does not follow the account.',
      params: [
        {
          // Ветку называет ЗАГОЛОВОК ШАГА, поэтому у полей подписи простые.
          name: 'noSubText',
          type: 'string',
          required: true,
          default: T.noSub,
          typeOptions: { rows: 3 },
          displayName: ru ? 'Сообщение' : 'Message',
          placeholder: ru ? 'Напишите сообщение' : 'Write a message',
          description: ru
            ? 'Отправляется, если пользователь нажал кнопку, но ещё не подписан'
            : 'Sent if the user tapped the button but has not subscribed yet',
          displayOptions: { show: { checkSub: [true] } },
        },
        {
          name: 'noSubBtn',
          type: 'string',
          required: true,
          default: T.noSubBtn,
          displayName: ru ? 'Текст в кнопке' : 'Button text',
          placeholder: T.noSubBtn,
          description: ru
            ? 'По этой кнопке бот повторно проверит подписку'
            : 'This button makes the bot check the subscription again',
          displayOptions: { show: { checkSub: [true] } },
        },
      ],
    },
    {
      key: 'gift',
      title: ru ? 'Что получит пользователь' : 'What the user receives',
      intro: ru
        ? 'Бот отправит этот материал после выполнения условий.'
        : 'The bot sends this material once the conditions are met.',
      params: [
        {
          name: 'linkText',
          type: 'string',
          required: true,
          default: T.link,
          typeOptions: { rows: 3 },
          displayName: ru ? 'Сообщение' : 'Message',
          placeholder: ru ? 'Напишите сообщение' : 'Write a message',
        },
        // Обещанное можно отдать не только ссылкой: ссылка / картинка / видео / аудио /
        // файл — ровно то, что умеет шаг «Сообщение» в схеме.
        wizGiftKindParam('instagram', locale, { tgLink: true }),
        // Текст кнопки — сразу под выбором (у «Ссылки» и у «Ссылки в Telegram-бот»), затем куда кнопка ведёт.
        // Ссылка едет КНОПКОЙ внутри сообщения (шаблон Меты, IG-MESSAGE-LOOK Э2.1):
        // голый адрес в тексте Instagram разворачивал бы серой превью-карточкой. Текст
        // кнопки пишет человек (владелец 08.09.2026, Л1 п.9: «мастер Инстаграма = мастер
        // Телеграма по полям») — Мета берёт любой, шаблон отправки тот же.
        {
          name: 'linkBtn',
          type: 'string',
          required: true,
          default: T.openBtn,
          displayName: ru ? 'Текст в кнопке' : 'Button text',
          placeholder: ru ? 'Текст в кнопке' : 'Button text',
          // И У «ССЫЛКИ В TELEGRAM-БОТ» (владелец 25.10.2026, ТЗ TGLINK-BTN): она уходит той же кнопкой, а надпись
          // человек пишет любую — «Забрать план», без обязательного «откроется Телеграм». Стоит СРАЗУ под «Что
          // отправить» у обоих вариантов (замечание владельца 25.10.2026): кнопка → потом куда она ведёт.
          displayOptions: { show: { [WIZ_GIFT_KIND]: [WIZ_GIFT_LINK, WIZ_GIFT_TG] } },
        },
        // Вариант «Ссылка в Telegram-бот» (UT 14.10.2026 п.6): бот, метка, готовая ссылка — под текстом кнопки.
        ...wizGiftTgParams(locale),
        {
          name: 'linkUrl',
          type: 'string',
          required: true,
          default: '',
          displayName: ru ? 'Ссылка' : 'Link',
          placeholder: 'https://…',
          description: ru
            ? 'Открывается по кнопке в сообщении, без карточки предпросмотра ссылки в переписке'
            : 'Opens from the button in the message, without a link preview card in the chat',
          displayOptions: { show: { [WIZ_GIFT_KIND]: [WIZ_GIFT_LINK] } },
        },
        wizGiftFileParam('instagram', locale),
      ],
    },
  ];
}

/** Выбор строки «Отвечать в комментариях» (круг 12, §18.0 п.5): нет / всем / только со словом. */
type IgReplyChoice = 'off' | 'all' | 'words';
/** Имена полей СТРАНИЦЫ строки — виртуальные: в ответах живут `commentReply`,
 *  `commentReplyMode` и `commentReplyWords`, страница их лишь переводит. */
const IG_REPLY_CHOICE_FIELD = 'commentReplyChoice';
const IG_REPLY_MATCH_FIELD = 'commentReplyMatch';

function replyChoiceOf(a: Record<string, unknown>): IgReplyChoice {
  if (!ansBool(a, 'commentReply', true)) return 'off';
  const raw = ansStr(a, IG_REPLY_MODE_FIELD, 16, 'all');
  return raw === 'exact' || raw === 'keyword' ? 'words' : 'all';
}

/**
 * СТРОКА «ОТВЕЧАТЬ В КОММЕНТАРИЯХ» — ОДНА СУЩНОСТЬ ВМЕСТО ТУМБЛЕРА И ВТОРОЙ СТРОКИ
 * (владелец 09.09.2026, круг 12, docs/CHAT-LOOK-PLAN.md §18.0 п.5: «вместо тумблера
 * кнопка, которая открывает шторку: отвечать всем / только на выбранные, и там уже
 * любой комментарий, содержит слово»). Живёт только при входе «любой комментарий»; при
 * входе со словом остаётся прежний тумблер (вход сам по себе отбор).
 *
 * Механика — `WizardStep.itemList` с потолком в один элемент: страницу полей полушторкой
 * с «Готово» умеет ровно он, и в браузере, и в приложении (`wizItemRowsOpen`; новых
 * методов моста нет, запрет №8). «Добавить»/«Удалить»/«Править» у списка из одного
 * элемента не бывает: слова пусты, а слово `edit` веб нативу для такого списка не шлёт.
 *
 * Поля страницы ВИРТУАЛЬНЫЕ (`commentReplyChoice`, `commentReplyMatch`): в ответах, как и
 * прежде, лежат `commentReply` (включён ли публичный ответ), `commentReplyMode`
 * (`all`/`keyword`/`exact`) и `commentReplyWords` — сборка схемы (Л5) не менялась.
 */
function replyRowList(locale: WizardLocale): WizardStepItemList {
  const ru = locale === 'ru';
  const title = ru ? 'Отвечать в комментариях' : 'Reply in comments';
  const wordsOfAns = (a: Record<string, unknown>) => wordsOf(ansStr(a, IG_REPLY_WORDS_FIELD, 300));
  const matchOf = (a: Record<string, unknown>) =>
    ansStr(a, IG_REPLY_MODE_FIELD, 16, 'all') === 'exact' ? 'exact' : 'keyword';
  // Два режима слова — ТЕ ЖЕ подписи, что у входа-комментария (свод один на мастер).
  const matchOptions = trigModeOptions(locale, 'comment').filter((o) => o.value !== 'any');
  return {
    max: 1,
    itemAdd: '',
    itemEmpty: '',
    itemRemove: '',
    itemTitle: title,
    // СТРОКА СТОИТ НАД «ВАРИАНТАМИ ОТВЕТА» (этап J п.1, владелец 09.09.2026): сперва
    // решают, отвечать ли публично, и только потом — какими словами. Порядок один на
    // браузер и приложение.
    first: true,
    // ВЫБОР «ТОЛЬКО НА КОММЕНТАРИИ СО СЛОВОМ» РАЗВОРАЧИВАЕТ ПОЛУШТОРКУ (этап J п.2):
    // под вариантами появляются режим и поле слова — на половине экрана их не видно.
    // Каретка сразу в поле слова: за ним человек сюда и пришёл.
    pageGrow: (answers) => replyChoiceOf(answers) === 'words',
    pageFocus: (answers) => (replyChoiceOf(answers) === 'words' ? IG_REPLY_WORDS_FIELD : ''),
    count: () => 1,
    line: (answers) => {
      const choice = replyChoiceOf(answers);
      if (choice === 'off') return { title, sub: ru ? 'Нет' : 'No' };
      if (choice === 'all') return { title, sub: ru ? 'Всем' : 'Everyone' };
      const head = matchOf(answers) === 'exact' ? (ru ? 'Ровно' : 'Exactly') : ru ? 'Содержит' : 'Contains';
      return { title, sub: `${head}: ${wordsOfAns(answers).join(', ') || trigWords(locale).empty}` };
    },
    fields: () => [
      {
        name: IG_REPLY_CHOICE_FIELD,
        type: 'options',
        required: true,
        default: 'all',
        displayName: ru ? 'Отвечать под комментарием' : 'Reply under the comment',
        description: ru
          ? 'Личное сообщение получают все. Здесь настраивается только публичный ответ под комментарием.'
          : 'Everyone receives the private message. This setting only controls the public reply under the comment.',
        options: [
          { name: ru ? 'Не отвечать' : 'Do not reply', value: 'off' },
          { name: ru ? 'Отвечать всем' : 'Reply to everyone', value: 'all' },
          { name: ru ? 'Только на комментарии со словом' : 'Only comments with the word', value: 'words' },
        ],
      },
      {
        name: IG_REPLY_MATCH_FIELD,
        type: 'options',
        required: true,
        default: 'keyword',
        displayName: ru ? 'Какой комментарий' : 'Which comment',
        options: matchOptions,
        displayOptions: { show: { [IG_REPLY_CHOICE_FIELD]: ['words'] } },
      },
      wizKeywordsParam(locale, { [IG_REPLY_CHOICE_FIELD]: ['words'] }, IG_REPLY_WORDS_FIELD),
    ],
    fieldValues: (answers) => ({
      [IG_REPLY_CHOICE_FIELD]: replyChoiceOf(answers),
      [IG_REPLY_MATCH_FIELD]: matchOf(answers),
      [IG_REPLY_WORDS_FIELD]: wordsOfAns(answers).join(', '),
    }),
    applyFields: (answers, _i, patch) => {
      const next = { ...answers };
      const choice: IgReplyChoice =
        IG_REPLY_CHOICE_FIELD in patch
          ? String(patch[IG_REPLY_CHOICE_FIELD]) === 'off'
            ? 'off'
            : String(patch[IG_REPLY_CHOICE_FIELD]) === 'words'
              ? 'words'
              : 'all'
          : replyChoiceOf(answers);
      const match =
        IG_REPLY_MATCH_FIELD in patch
          ? String(patch[IG_REPLY_MATCH_FIELD]) === 'exact'
            ? 'exact'
            : 'keyword'
          : matchOf(answers);
      next.commentReply = choice !== 'off';
      next[IG_REPLY_MODE_FIELD] = choice === 'words' ? match : 'all';
      // Слова приходят строкой (браузер) или списком (кружки родного экрана) — разбор
      // один на весь мастер (`wordsOfPatch`).
      if (IG_REPLY_WORDS_FIELD in patch) {
        next[IG_REPLY_WORDS_FIELD] = wordsOfPatch(patch[IG_REPLY_WORDS_FIELD]).join(', ');
      }
      return next;
    },
    // Элемент ровно один и всегда: добавлять и удалять нечего.
    add: (answers) => answers,
    remove: (answers) => answers,
    // Страница — ПОЛУШТОРКОЙ (§18.0 п.5): выбор, режим слова и слова, не больше.
    pageFull: () => false,
    canMove: false,
  };
}

/**
 * ПУБЛИЧНЫЕ ОТВЕТЫ ПОД КОММЕНТАРИЕМ — отдельный шаг (владелец 2026-08-06). `only` —
 * условие показа ВСЕГО шага (§5): у анкеты с выбором входов он живёт, только пока
 * отмечен вход-комментарий. Шаг, у которого все поля скрыты, панель пропускает сама —
 * тем же способом гаснут шаги без проверки подписки, своей механики «скрыть шаг» нет.
 */
/**
 * ШАГ ПУБЛИЧНЫХ ОТВЕТОВ. Стоит он только там, где комментарий вообще триггер — и решает
 * это САМ НАБОР ШАГОВ (`dynamicSteps`), а не скрытые поля: с 06.09 входы живут списком
 * `entries`, и прежнего условия показа по галочкам `entryEvents` больше нет (К18.3 этап 2).
 */
/**
 * @param replyRow — вход-комментарий стоит «любой»: на шаге вместо тумблера живёт строка
 * «Отвечать в комментариях» (§18.0 п.5). При входе со словом шаг прежний.
 */
function commentsStep(locale: WizardLocale, replyRow = false): WizardStep {
  const ru = locale === 'ru';
  const T = IG_TXT[locale];
  // ТУМБЛЕР — только при входе со словом; при входе «любой комментарий» его место занимает
  // строка-полушторка «Отвечать в комментариях» (§18.0 п.5) — двух сущностей нет.
  const toggle: CatalogParam = {
    name: 'commentReply',
    type: 'boolean',
    required: true,
    default: true,
    displayName: ru ? 'Отвечать в комментариях' : 'Reply in comments',
    description: ru
      ? 'Помимо личного сообщения бот публично ответит под комментарием'
      : 'In addition to the private message, the bot replies publicly under the comment',
  };
  return {
    key: 'comments',
    title: ru ? 'Ответы в комментариях' : 'Replies in comments',
    intro: ru
      ? 'В личные сообщения бот отвечает всегда. Здесь настраивается, отвечать ли также публично, под комментарием.'
      : 'The bot always replies in direct messages. Here you set whether it also replies publicly, under the comment.',
    // Строка-полушторка — только при входе «любой комментарий» (§18.0 п.5); в браузере и
    // в приложении порядок один: сперва поля шага (варианты ответа), потом строка.
    ...(replyRow ? { itemList: replyRowList(locale) } : {}),
    params: ([
      ...(replyRow ? [] : [toggle]),
      // Список ответов рисует свой контрол панели: строка = поле, любое количество.
      // Хранится одной строкой с переводами строк — сборка не менялась.
      {
        name: 'commentTexts',
        type: 'string',
        required: true,
        default: T.replies,
        displayName: ru ? 'Варианты ответа' : 'Reply variants',
        // ПОЯСНЕНИЕ ПОД СТРОКОЙ «Варианты ответа» и сверху её шторки (ТЗ USERTEST-1014 п.7, владелец 14.10.2026).
        description: ru
          ? 'Бот отвечает одним из вариантов, выбирая случайно. Несколько разных ответов нужны, чтобы Instagram не счёл одинаковые ответы спамом.'
          : 'The bot replies with one of the options, chosen at random. Several different replies are needed so that Instagram does not treat identical replies as spam.',
        displayOptions: { show: { commentReply: [true] } },
      },
    ] as CatalogParam[]),
  };
}

/**
 * НАПОМИНАНИЕ С ЗАДЕРЖКОЙ ЖИВЁТ НЕ У ВСЯКОГО ВХОДА (владелец 05.09.2026,
 * docs/CHAT-LOOK-PLAN.md 14.3). Комментарий под публикацией и комментарий в эфире суток
 * ответа не открывают: Мета разрешает на них РОВНО ОДИН личный ответ, а дальше писать
 * можно только после ответа человека. Значит у бота, которого запускают ТОЛЬКО такие
 * входы, напоминание через десять минут не уйдёт никогда — опции нет ни на экране, ни в
 * схеме. Есть хоть один вход с окном — опция стоит, а под ней честная оговорка.
 * Правда о входах — свод `IG_START_EVENTS` (`opens24h`), своего списка тут нет.
 */
function remindParams(locale: WizardLocale, windowOpen: boolean): CatalogParam[] {
  const ru = locale === 'ru';
  const T = IG_TXT[locale];
  // Есть ли среди триггеров хоть один с окном ответа — считает набор шагов по САМИМ
  // триггерам (`dynamicSteps`): скрытых полей по галочкам `entryEvents` больше нет.
  if (!windowOpen) return [];
  return [
    {
      name: 'remind',
      type: 'boolean',
      required: true,
      default: false,
      displayName: ru ? 'Напомнить про подарок' : 'Remind about the gift',
      description: ru
        ? 'Отправится через 10 минут. Для комментариев не работает: Instagram не позволяет писать пользователю без его ответа'
        : 'Sent after 10 minutes. It does not work for comments: Instagram does not allow writing to a user without their reply',
    },
    {
      name: 'remindText',
      type: 'string',
      required: true,
      default: T.remind,
      typeOptions: { rows: 3 },
      displayName: ru ? 'Текст напоминания' : 'Reminder text',
      placeholder: ru ? 'Напишите сообщение' : 'Write a message',
      displayOptions: { show: { remind: [true] } },
    },
  ];
}

function additionalStep(locale: WizardLocale, windowOpen: boolean): WizardStep {
  const ru = locale === 'ru';
  const remind = remindParams(locale, windowOpen);
  return {
    key: 'additional',
    title: ru ? 'Дополнительные настройки' : 'Additional settings',
    // Напоминания у этой анкеты нет вовсе (входы без окна) — подводка про «догоняет тех,
    // кто не нажал кнопку» стала бы обещанием того, чего на экране нет.
    intro:
      remind.length > 0
        ? ru
          ? 'Напоминание тем, кто не нажал кнопку, и дополнительное сообщение после выдачи материала.'
          : 'A reminder for users who did not tap the button, and a follow-up message after the material is delivered.'
        : ru
          ? 'Дополнительное сообщение после выдачи материала.'
          : 'A follow-up message after the material is delivered.',
    params: [
      ...remind,
      {
        name: 'extra',
        type: 'boolean',
        required: true,
        default: false,
        displayName: ru ? 'Дополнительное сообщение' : 'Follow-up message',
        description: ru
          ? 'Отправляется через указанное количество минут после выдачи материала'
          : 'Sent the specified number of minutes after the material is delivered',
      },
      {
        name: 'extraText',
        type: 'string',
        required: true,
        // ПРИМЕР ПО УМОЛЧАНИЮ (ТЗ USERTEST-1014 п.8, владелец 14.10.2026): включил — видно, что писать.
        default: EXTRA_TEXT_SAMPLE[locale],
        // ДВЕ строки, не три (владелец 2026-08-06): лишняя пустая строка читалась дырой между полями.
        typeOptions: { rows: 2 },
        displayName: ru ? 'Сообщение' : 'Message',
        placeholder: ru ? 'Сообщение или ссылка' : 'Message or link',
        displayOptions: { show: { extra: [true] } },
      },
      {
        name: 'extraMinutes',
        type: 'number',
        required: true,
        default: 10,
        typeOptions: { minValue: 1, maxValue: 10080 },
        displayName: ru ? 'Интервал, минут' : 'Interval, minutes',
        displayOptions: { show: { extra: [true] } },
      },
      // СРОК БОТА — ПОСЛЕДНИМ ПОЛЕМ (владелец 08.09.2026, Л1 п.5): пока человек внутри
      // бота, все его сообщения идут этому боту, и отпускает его только конец сценария
      // или молчание дольше этого срока. В базе черновика это `holdTimeoutMin` (минуты).
      {
        name: 'finishHours',
        type: 'number',
        required: true,
        default: 24,
        typeOptions: { minValue: 1, maxValue: 720 },
        displayName: ru ? 'Завершать разговор через (часов)' : 'Finish the conversation after (hours)',
        description: ru
          ? 'Разговор считается завершённым, когда цель бота достигнута или пользователь молчит дольше указанного времени. Пока пользователь отвечает этому боту, другие боты ему не пишут — иначе путаница.'
          : 'The conversation counts as finished when the bot has reached its goal or the user stays silent longer than this. While the user is replying to this bot, other bots do not write to them — otherwise it gets confusing.',
      },
      // «НЕ ЗАПУСКАТЬ ПОВТОРНО» — САМЫМИ ПОСЛЕДНИМИ ПОЛЯМИ (владелец 09.09.2026, Л5.1
      // п.1): выключено по умолчанию, включили — держим человека вне бота столько дней,
      // сколько он выбрал. В черновике это `antiRepeatMin` (МИНУТЫ, дни × 1440).
      ...noRepeatParams(locale),
    ],
  };
}

/** «Не запускать повторно» — общая пара полей ОБЕИХ анкет Инстаграма (Л5.1 п.1).
 *  Дни, а не минуты: клиенту про минуты защиты знать незачем, в базу их переводит
 *  `triggerMeta`. Второй копии этих подписей в анкетах Инстаграма нет. */
function noRepeatParams(locale: WizardLocale): CatalogParam[] {
  const ru = locale === 'ru';
  return [
    {
      name: 'noRepeat',
      type: 'boolean',
      required: true,
      default: false,
      displayName: ru ? 'Не запускать повторно' : 'Do not start again',
      description: ru
        ? 'Тот, кто уже запускал бота, не запустит его снова своими сообщениями и комментариями в течение указанного числа дней'
        : 'Someone who has already started the bot cannot start it again with their messages or comments for the specified number of days',
    },
    {
      name: 'noRepeatDays',
      type: 'number',
      required: true,
      default: 30,
      typeOptions: { minValue: 1, maxValue: 365 },
      displayName: ru ? 'дней' : 'days',
      displayOptions: { show: { noRepeat: [true] } },
    },
  ];
}

// ── Сборка канона ─────────────────────────────────────────────────────────────────────

function buildIgWorkflow(
  template: WorkflowJson,
  a: IgAnswers,
  locale: WizardLocale,
): WorkflowJson {
  const T = IG_TXT[locale];
  let wf = template;

  // ВХОДЫ — В САМ УЗЕЛ ЗАПУСКА (§3.4): «Старт» один, событий у него столько, сколько
  // человек отметил. Прежнее одиночное `event` из канона шаблона стирается: список
  // входов — единственная правда.
  wf = {
    ...wf,
    nodes: wf.nodes.map((n) => {
      if (n.name !== N.start) return n;
      const { event: _drop, ...rest } = (n.parameters ?? {}) as Record<string, unknown>;
      return { ...n, parameters: { ...rest, events: [...a.events] } };
    }),
  };

  // Ветки входа: комментарий и эфир получают ЛИЧНЫЙ ответ (одно сообщение, [M6]),
  // директ и истории — обычное сообщение. Ветка заводится только под отмеченный вход.
  const branches: IgBranch[] = (['comment', 'live', 'direct'] as IgBranch[]).filter((b) =>
    a.events.some((e) => branchOf(e) === b),
  );
  const wComment = T.wComment;
  const wLive = T.wLive;
  // Публичный ответ под комментарием (Э3.1) + защита от повтора (Э3.4): метка
  // «ответ в комментариях <публикация>» в «Контактах» — одному человеку под одной
  // публикацией отвечаем один раз, личное сообщение уходит всегда.
  const replies =
    branches.includes('comment') && a.commentReply && a.commentTexts.length > 0 ? a.commentTexts : null;
  // ПУБЛИЧНО ОТВЕЧАЕМ ТОЛЬКО НА КОММЕНТАРИЙ СО СЛОВОМ (Л5.1 п.2): при входе «любой
  // комментарий» человек может задать отбор — тогда перед всей веткой публичного ответа
  // встаёт развилка по тексту комментария. Режим стоит, а слов нет — отбора НЕТ вовсе
  // (то же правило, что у входа: пустой список слов молча убил бы публичный ответ).
  const replyWords =
    replies && a.commentReplyMode !== 'all' && a.commentReplyWords.length > 0
      ? a.commentReplyWords
      : null;
  // Сдвиг вправо для узлов публичного ответа: перед ними встал ещё один узел.
  const dx = replyWords ? 270 : 0;
  // Голова ветвления: одна ветка — сразу её начало, несколько — развилка «Откуда пришёл».
  // ОДИН ПУБЛИЧНЫЙ ОТВЕТ ЧЕЛОВЕКУ ПОД ПОСТОМ, и выбора тут нет (Л1 п.9): голова ветки
  // комментария — проверка «уже отвечали?», а с отбором по слову — сам отбор (Л5.1 п.2:
  // не совпало — ни публичного ответа, ни метки, личное сообщение уходит как обычно).
  const commentHead = replies ? (replyWords ? T.tWords : T.tCheck) : wComment;
  const headOf: Record<IgBranch, string> = { comment: commentHead, live: wLive, direct: N.welcome };
  const entryHead = branches.length > 1 ? T.nRouter : headOf[branches[0] ?? 'direct'];

  // Узлы веток заводим ДО правки связей: развилка входящего ведёт в голову ветвления,
  // а её узла в каноне шаблона нет. Метка «уже отвечали» привязана к публикации: под
  // другим постом бот снова ответит публично.
  const tagExpr = `={{ '${T.tagPrefix}' + $('${N.start}').first().json.mediaId }}`;
  const extraNodes: WorkflowNode[] = [];
  if (branches.length > 1) {
    extraNodes.push({
      id: 'wiz-entry-router',
      name: T.nRouter,
      type: 'n8n-nodes-base.switch',
      typeVersion: 3.2,
      position: [540, -200],
      notes: T.noteRouter,
      parameters: wizSwitchParams(
        branches.slice(0, -1).map((b) => eventPill(b, b === 'comment' ? T.outComment : T.outLive)),
        branches[branches.length - 1] === 'direct'
          ? T.outDirect
          : branches[branches.length - 1] === 'comment'
            ? T.outComment
            : T.outLive,
      ),
    });
  }
  if (branches.includes('comment')) {
    if (replies) {
      // ОТБОР ПО СЛОВУ — ПЕРВЫМ УЗЛОМ ВЕТКИ (Л5.1 п.2, порядок узлов оттуда же): сперва
      // фильтр по тексту комментария, потом «уже отвечали под этим постом?», и только
      // потом сам ответ и метка — иначе метка «ответ в комментариях» досталась бы и тем,
      // кому публично не ответили. Ряды сшиты «или», оператор — как у входа: 'eq' у
      // «определённого комментария», 'contains' у «содержит слово» (Л5.3: сравнение без
      // учёта регистра, нормализации нет).
      if (replyWords) {
        extraNodes.push({
          id: 'wiz-reply-words',
          name: T.tWords,
          type: 'n8n-nodes-base.switch',
          typeVersion: 3.2,
          position: [810, -360],
          notes: T.noteWords,
          parameters: wizSwitchParams(
            [
              {
                outputKey: T.outWords,
                group: {
                  rows: replyWords.map((w, i) =>
                    wizMsgRow(`rw-${i}`, AT, w, a.commentReplyMode === 'exact' ? 'eq' : 'contains'),
                  ),
                  any: true,
                },
              },
            ],
            T.outNoWords,
          ),
        });
      }
      extraNodes.push(
        {
          id: 'wiz-reply-check',
          name: T.tCheck,
          type: 'CUSTOM.scripteraContacts',
          typeVersion: 1,
          position: [810 + dx, -360],
          notes: T.noteCheck,
          parameters: {
            tags: tagExpr,
            source: 'manual',
            channel: 'instagram',
            checkMode: 'any',
            operation: 'check',
            externalId: SENDER,
          },
        },
        {
          id: 'wiz-reply-if',
          name: T.tIf,
          type: 'n8n-nodes-base.if',
          typeVersion: 2.2,
          position: [1080 + dx, -360],
          // Подписи у карточки условия нет НАРОЧНО (CONDITIONS У0): её собирает из рядов
          // сам кабинет, а рукописная устаревает в тот миг, когда человек поправил ряд.
          parameters: {
            conditions: {
              options: { version: 2, caseSensitive: true, typeValidation: 'loose' },
              combinator: 'and',
              conditions: [
                {
                  id: 'reply-if-0',
                  operator: { type: 'boolean', operation: 'true', singleValue: true },
                  leftValue: `={{ $('${T.tCheck}').first().json.passed === true }}`,
                  rightValue: '',
                },
              ],
            },
            looseTypeValidation: true,
          },
        },
        {
          id: 'wiz-reply-tag',
          name: T.tTag,
          type: 'CUSTOM.scripteraContacts',
          typeVersion: 1,
          position: [1620 + dx, -300],
          notes: T.noteTag,
          parameters: {
            tags: tagExpr,
            source: 'manual',
            channel: 'instagram',
            operation: 'addTags',
            externalId: SENDER,
          },
        },
      );
      extraNodes.push({
        id: 'wiz-reply-pub',
        name: T.tPub,
        type: 'CUSTOM.instagram',
        typeVersion: 1,
        position: [1350 + dx, -300],
        notes: T.notePub,
        parameters: {
          operation: 'replyComment',
          commentId: `={{ $('${N.start}').first().json.commentId }}`,
          text: replies[0],
          ...(replies.length > 1 ? { variants: replies.slice(1) } : {}),
        },
      });
    }
    extraNodes.push({
      id: 'wiz-welcome-comment',
      name: wComment,
      type: 'CUSTOM.instagram',
      typeVersion: 1,
      position: [1890 + dx, -360],
      notes: T.noteWelcomePrivate,
      parameters: {
        operation: 'replyPrivate',
        commentId: `={{ $('${N.start}').first().json.commentId }}`,
        text: a.welcomeText,
        ...bubble(a.welcomeBtn),
      },
    });
  }
  if (branches.includes('live')) {
    extraNodes.push({
      id: 'wiz-welcome-live',
      name: wLive,
      type: 'CUSTOM.instagram',
      typeVersion: 1,
      position: [1890, -180],
      notes: T.noteWelcomeLive,
      parameters: {
        operation: 'replyPrivate',
        commentId: `={{ $('${N.start}').first().json.commentId }}`,
        text: a.welcomeText,
        ...bubble(a.welcomeBtn),
      },
    });
  }
  if (extraNodes.length > 0) wf = { ...wf, nodes: [...wf.nodes, ...extraNodes] };

  // Приветствие и сообщение со ссылкой. Ссылка — КНОПКОЙ «Открыть» внутри сообщения
  // (IG-MESSAGE-LOOK Э2.1): голый адрес в тексте Instagram разворачивает серой
  // превью-карточкой. Без адреса (ответам не доверяем) — по-старому заглушкой в тексте.
  wf = wfSetParams(wf, N.welcome, { text: a.welcomeText, ...bubble(a.welcomeBtn) });
  if (a.gift.kind === WIZ_GIFT_LINK) {
    wf = wfSetParams(
      wf,
      N.give,
      a.linkUrl
        ? { text: a.linkText, buttons: { button: [{ title: a.linkBtn, kind: 'link', url: a.linkUrl }] } }
        : { text: `${a.linkText}\n\n${T.linkStub}` },
    );
  } else {
    // Вместо ссылки — вложение: сообщение остаётся текстом, а файл уходит СЛЕДОМ
    // отдельным шагом (правило канала: в теле запроса Меты либо text, либо attachment).
    // Параметры шага пишет общий writeStepAttach — тот же формат, что у редактора схемы.
    wf = wfSetParams(wf, N.give, { text: a.linkText });
    wf = wfInsertAfter(
      wf,
      N.give,
      wizAttachNode({
        id: 'wiz-gift-file',
        name: wizAttachNodeName(a.gift.kind, locale === 'ru'),
        channel: 'instagram',
        kind: a.gift.kind,
        url: a.gift.file,
        recipient: SENDER,
      }),
    );
  }

  if (a.checkSub) {
    // ЛЮБОЕ СООБЩЕНИЕ ЗАНОВО ПРОВЕРЯЕТ ПОДПИСКУ (владелец 2026-08-07).
    // Кнопки Instagram рисует ТОЛЬКО в мобильном приложении — в instagram.com их не
    // видно, и человек с компьютера физически не может нажать «Готово»: раньше он
    // застревал на просьбе подписаться навсегда. Поэтому у развилки входящего ТРИ
    // смысла: кодовое слово — начать разговор, подпись кнопки — проверить подписку,
    // ЛЮБОЕ ДРУГОЕ сообщение — тоже проверить подписку (запасной выход).
    // Дойти сюда «любое другое» может только тот, кто УЖЕ в воронке: диспетчер отдаёт
    // сценарию чужой текст лишь по замку «Работать без прерывания» (holdDialog).
    // ВХОДЫ СО СЛОВОМ И БЕЗ (ТЗ 02.09 §3.1, доводка координатора 02.09): у каждого
    // входа своя чувствительность. Слова всех входов «содержит/определённое» — одна
    // пилюля «Кодовое слово» (ряды «или», у каждого слова оператор своего входа).
    // Входы БЕЗ слова (комментарий «любое», реакция, отметка, история «любое») в
    // сообщении словом не узнаются — их узнаёт по СОБЫТИЮ развилка «Откуда пришёл
    // (без слова)», куда уходит запасной выход. Иначе реакция на историю уезжала бы на
    // «подпишись» вместо приветствия (найдено при приёмке на живой схеме).
    const wordEntries = a.events.filter((e) => (a.entry[e]?.kind ?? 'any') !== 'any');
    const anyEvents = a.events.filter((e) => (a.entry[e]?.kind ?? 'any') === 'any');
    const wordRows = wordEntries.flatMap((e, ei) =>
      (a.entry[e]?.keywords ?? []).map((w, wi) =>
        wizMsgRow(`sw-word-${ei}-${wi}`, AT, w, a.entry[e]?.kind === 'exact' ? 'eq' : 'contains'),
      ),
    );
    const pills: WizPill[] = [btnPill('sw-btn-0', a.welcomeBtn), btnPill('sw-btn-1', a.noSubBtn)];
    const outs: string[] = [N.condSub, N.condSub];
    if (wordRows.length > 0) {
      pills.push({ outputKey: T.outEntry, group: { rows: wordRows, any: true } });
      outs.push(entryHead);
    }
    // Запасной выход: (а) входов без слова нет — любой другой текст заново проверяет
    // подписку; (б) единственный вход без слова — личка «любое» — всё остальное и есть
    // начало разговора; (в) иначе — развилка по событию, её запасной выход: личка
    // «любое» → приветствие, нет её → проверка подписки.
    const messageAny = (a.entry.message?.kind ?? null) === 'any';
    // «УЖЕ ПОЛУЧИЛ?» ПЕРЕД ЦЕЛЬЮ СЛУЧАЙНОГО ТЕКСТА (владелец 16.10.2026, ТЗ GIFT-REPEAT):
    // «спасибо» после выдачи — не просьба, получивший слышит тишину, не получивший идёт
    // туда же, куда раньше. Пара ровно одна: на запасной выход развилки входящего или,
    // когда он ведёт в «Откуда пришёл (без слова)», — на её запасной выход. Входы без
    // слова (комментарий, реакция, отметка, история) пилюлями той развилки идут мимо.
    const gotGate = (target: string): string => {
      const g = gotGateTexts(locale);
      // Метку проверяем ту, что ставит выдача (канон «Метка: получил чек-лист»).
      const tags = (wf.nodes.find((n) => n.name === N.tag)?.parameters as Record<string, unknown> | undefined)
        ?.tags;
      wf = wfGotGate(wf, {
        check: {
          id: 'wiz-got-check-in',
          name: g.nCheck,
          type: 'CUSTOM.scripteraContacts',
          typeVersion: 1,
          position: [0, 0],
          notes: g.noteCheck,
          parameters: {
            operation: 'check',
            checkMode: 'any',
            ...(typeof tags === 'string' ? { tags } : {}),
            source: 'manual',
            channel: 'instagram',
            externalId: SENDER,
          },
        },
        ifId: 'wiz-got-if-in',
        ifName: g.nIf,
        target,
      });
      return g.nCheck;
    };
    let fallbackTarget: string;
    if (anyEvents.length === 0) fallbackTarget = gotGate(N.condSub);
    else if (anyEvents.length === 1 && anyEvents[0] === 'message') fallbackTarget = gotGate(N.welcome);
    else {
      const byBranch = (b: IgBranch) => anyEvents.filter((e) => branchOf(e) === b && e !== 'message');
      const routerPills: WizPill[] = [];
      const routerOuts: string[] = [];
      for (const b of ['comment', 'live', 'direct'] as IgBranch[]) {
        const evs = byBranch(b);
        if (evs.length === 0) continue;
        if (b === 'direct' && messageAny) continue; // личка «любое» покрывается запасным выходом
        routerPills.push(
          eventsPill(evs, b === 'comment' ? T.outComment : b === 'live' ? T.outLive : T.outDirect, `sw-any-${b}`),
        );
        routerOuts.push(headOf[b]);
      }
      const routerFallback = gotGate(messageAny ? N.welcome : N.condSub);
      wf = {
        ...wf,
        nodes: [
          ...wf.nodes,
          {
            id: 'wiz-entry-router-any',
            name: T.nRouterAny,
            type: 'n8n-nodes-base.switch',
            typeVersion: 3.2,
            position: [540, 200],
            notes: T.noteRouterAny,
            parameters: wizSwitchParams(routerPills, messageAny ? T.outDirect : T.outOther),
          },
        ],
      };
      wf = wfSetOuts(wf, T.nRouterAny, [...routerOuts, routerFallback]);
      fallbackTarget = T.nRouterAny;
    }
    outs.push(fallbackTarget);
    wf = wfSetParams(
      wf,
      N.btnSwitch,
      // Подпись запасного выхода — по смыслу, а не по цели (цель теперь — «Уже получил?»):
      // нет входов без слова — это «любое другое сообщение».
      wizSwitchParams(pills, anyEvents.length === 0 || wordRows.length > 0 ? T.outOther : T.outEntry),
    );
    wf = wfSetOuts(wf, N.btnSwitch, outs);
    if (wordRows.length > 0) wf = wfSetNotes(wf, N.btnSwitch, T.noteSwitch);
    wf = wfSetParams(wf, N.noSub, { text: a.noSubText, ...bubble(a.noSubBtn) });
  } else {
    // Проверка подписки выключена → ветка подписки выбрасывается, кнопка приветствия
    // ведёт сразу к выдаче; у развилки остаются два выхода (кнопка и кодовое слово).
    wf = wfDropNodes(wf, [N.condSub, N.noSub]);
    // Запасной выход («любое другое сообщение») ведёт к приветствию, как и раньше:
    // отличить вход в воронку от продолжения разговора здесь нечем. Поэтому «Уже
    // получил?» (16.10.2026) сюда НЕ ставится: через этот выход идут и входы (комментарий
    // со словом, реакция, отметка) — их по решению 20.09 обслуживаем снова. Подарка этот
    // выход не выдаёт: случайный текст получает приветствие, не материал.
    wf = wfSetParams(
      wf,
      N.btnSwitch,
      wizSwitchParams([btnPill('sw-btn-0', a.welcomeBtn)], T.outEntry),
    );
    wf = wfSetOuts(wf, N.btnSwitch, [N.give, entryHead]);
  }

  // Напоминание — идиома wait + проверка метки «получил чек-лист».
  if (!a.remind) wf = wfDropNodes(wf, [N.wait10, N.checkGot, N.ifGot, N.remindMsg]);
  else wf = wfSetParams(wf, N.remindMsg, { text: a.remindText, ...bubble(a.welcomeBtn) });

  // Догрев.
  if (!a.extra) wf = wfDropNodes(wf, [N.warm, N.extraMsg]);
  else {
    wf = wfSetParams(wf, N.warm, { amount: a.extraMinutes });
    wf = wfSetParams(wf, N.extraMsg, { text: a.extraText });
  }

  // ── ПРОВЕРКИ «ПОДАРОК УЖЕ ВЫДАВАЛИ?» БОЛЬШЕ НЕТ (владелец 20.09.2026) ───────────────
  // До этого дня на путях случайного текста перед выдачей стояла пара «смотрим карточку —
  // метка есть, молчим (а с 20.09 утром — отвечаем „мы уже общались“)». Владелец: «убери,
  // она тупая — материал отдаём ещё раз, просто и всё». Случайный текст внутри разговора
  // идёт туда же, куда вёл раньше: на проверку подписки и выдачу. Метка «получил чек-лист»
  // остаётся — по ней считается цель и по ней же напоминание обходит получивших.
  // УТОЧНЕНИЕ 16.10.2026 (владелец, ТЗ GIFT-REPEAT): на пути ПРОСЬБЫ (кнопка, кодовое
  // слово, комментарий, реакция, отметка) проверки по-прежнему нет — отдаём снова. А на
  // запасном выходе развилки входящего (случайный текст внутри разговора) перед прежней
  // целью стоит «Уже получил?» (gotGate выше): получивший на «спасибо» слышит тишину.

  // ── СВЯЗИ ВЕТОК ВХОДА ───────────────────────────────────────────────────────────────
  // Общая цепочка (проверка подписки, выдача, напоминание) у бота ОДНА: все приветствия
  // сходятся туда, куда вело приветствие канона. Дублировать её по веткам запрещено.
  const link = (from: string, outs: Array<Array<string | { node: string }>>) => {
    wf = {
      ...wf,
      connections: {
        ...wf.connections,
        [from]: {
          ...(wf.connections[from] ?? {}),
          main: outs.map((names) =>
            names.map((n) => ({ node: typeof n === 'string' ? n : n.node, type: 'main' as const, index: 0 })),
          ),
        } as (typeof wf.connections)[string],
      },
    };
  };
  if (branches.length > 1) link(T.nRouter, branches.map((b) => [headOf[b]]));
  if (branches.includes('comment')) {
    if (replies) {
      // Слово не совпало — мимо публичного ответа и метки, сразу к личному сообщению.
      if (replyWords) link(T.tWords, [[T.tCheck], [wComment]]);
      link(T.tCheck, [[T.tIf]]);
      // Уже отвечали — публичный ответ пропускаем, личное сообщение уходит всегда.
      link(T.tIf, [[wComment], [T.tPub]]);
      link(T.tPub, [[T.tTag]]);
      link(T.tTag, [[wComment]]);
    }
    // ХВОСТА У ПРИВЕТСТВИЯ КОММЕНТАРИЯ НЕТ (К27.1 п.6): комментарий и эфир суток ответа
    // не открывают — Мета разрешает ровно одно личное сообщение, и «Подождать 10 минут»
    // после него уходило в отказ. Разговор продолжает нажатие кнопки: оно приходит новым
    // сообщением и запускает сценарий заново (идиома IG, шапка файла).
    link(wComment, [[]]);
  }
  if (branches.includes('live')) link(wLive, [[]]);
  // Директа среди входов нет — приветствие канона (обычное сообщение) не нужно вовсе.
  if (!branches.includes('direct')) wf = wfDropNodes(wf, [N.welcome]);

  // Картинка к приветствию — отдельным сообщением перед текстом (тот же формат
  // вложения, что у редактора схемы: параметры пишет writeStepAttach). ТОЛЬКО в ветке
  // директа (К27.1 п.5): под комментарием и в эфире у Меты нет открытой переписки —
  // картинка отдельным сообщением падает, и личный ответ на комментарий не уходит вовсе.
  // Нет ветки директа — узла картинки в схеме нет, а поле анкеты говорит об этом словами.
  if (a.welcomeImage && branches.includes('direct')) {
    wf = wfInsertBefore(
      wf,
      N.welcome,
      wizAttachNode({
        id: 'wiz-welcome-photo',
        name: T.nPhoto,
        channel: 'instagram',
        kind: 'image',
        url: a.welcomeImage,
        recipient: SENDER,
      }),
    );
  }

  // ── ПРОВЕРКА ПОДПИСКИ — ТОЛЬКО ТАМ, ГДЕ ЕЁ ОТВЕТ ЧИТАЮТ (владелец 20.10.2026) ──────
  // В каноне «Профиль собеседника» стоял сразу за «Стартом» — на КАЖДОЕ событие, включая
  // комментарий, которому подписка не нужна вовсе: ответ под комментарием и приветствие с
  // кнопкой от неё не зависят. А Мета на первое обращение нового человека профиль не
  // отдаёт (код 230, узел повторяет три раза по 3 с) — бот «Кодовое слово 1» 19.10 отвечал
  // на комментарий 10,6 с вместо 1 с. Теперь профиль спрашивается перед «Подписан?» — после
  // нажатия кнопки «Готово», по кодовому слову и случайному тексту внутри разговора, когда
  // согласие у Меты уже есть. Карточка человека заводится тем, что принёс «Старт» (у
  // комментария есть ник; имя дотянет сверка переписок). Пустые поля узел контактов не
  // пишет (bot-contacts: пустая строка = «не трогать»).
  const profileNode = wf.nodes.find((n) => n.name === N.profile);
  if (profileNode) {
    wf = wfDropNodes(wf, [N.profile]);
    wf = wfConnect(wf, N.start, 0, N.saveContact);
    wf = wfSetParams(wf, N.saveContact, {
      name: '',
      username: `={{ $('${N.start}').first().json.senderUsername || '' }}`,
    });
    if (a.checkSub) wf = wfInsertBefore(wf, N.condSub, profileNode);
  }

  // Имена узлов-сообщений — по новым текстам (как режет конвейер переносов).
  // Имена приветствий заданы ТЗ дословно («Приветствие», «Приветствие (комментарий)»,
  // «Приветствие (эфир)») — их не переименовываем по тексту сообщения: по ним человек
  // читает, из какой ветки пришёл ответ.
  const taken = new Set(wf.nodes.map((n) => n.name));
  const renames: Array<[string, string]> = [];
  const plan = (oldName: string, text: string, fallback: string) => {
    if (!wf.nodes.some((n) => n.name === oldName)) return;
    taken.delete(oldName);
    const next = wizNodeTitle(text, taken, fallback);
    if (next !== oldName) renames.push([oldName, next]);
  };
  if (a.checkSub) plan(N.noSub, a.noSubText, T.nNoSub);
  plan(N.give, a.linkText, T.nGive);
  if (a.remind) plan(N.remindMsg, a.remindText, T.nRemind);
  if (a.extra) {
    plan(N.warm, T.nDelayMin(a.extraMinutes), T.nDelay);
    plan(N.extraMsg, a.extraText, T.nExtra);
  }
  for (const [oldName, next] of renames) wf = wfRenameNode(wf, oldName, next);

  return wf;
}

/**
 * СЛОВО ЧЕЛОВЕКА В ПРЕВЬЮ (§5: «сцена по первому отмеченному событию»). Берётся настройка
 * НУЖНОГО входа: у переписки — первого отмеченного, у вида «Комментарий» — комментария.
 * Вход «на любое сообщение» слова не имеет — там в превью стоит обычное приветствие.
 */
function entryWord(a: IgAnswers, event?: BotEntryEvent): string {
  const one = a.entry[event ?? a.events[0] ?? 'message'];
  return one && one.kind !== 'any' ? (one.keywords[0] ?? '') : '';
}

/** ВХОДЫ БОТА ПО ОТВЕТАМ (§3.2) — одни и те же у диспетчера и у предохранителя от копий.
 *  Подписи кнопок сюда НЕ входят: это внутренняя механика роутинга, её добавляет синк
 *  маршрутов сам (§3.5), и на карточке бота её не показывают. */
export function entriesOf(a: IgAnswers): BotEntry[] {
  return a.events.map((event) => {
    const one = a.entry[event] ?? { kind: 'any' as const, keywords: [], mediaIds: [] };
    return botEntry(event, one.kind, { keywords: one.keywords, mediaIds: one.mediaIds });
  });
}

/**
 * ШАГИ АНКЕТЫ ПРИ ЗАДАННЫХ ТРИГГЕРАХ. `events === null` — полный набор (умолчания полей,
 * счётчик шагов до первого ответа).
 *
 * Публичный ответ под комментарием — ОТДЕЛЬНЫЙ ШАГ (владелец 2026-08-06) и только там,
 * где комментарий вообще триггер: в эфире и историях публичных ответов нет.
 */
function igSteps(
  locale: WizardLocale,
  cfg: IgWizardCfg,
  events: readonly BotEntryEvent[] | null,
  replyRow = false,
): WizardStep[] {
  const hasComment = events === null || events.includes('comment');
  // Напоминание живёт не у всякого триггера: комментарий и эфир суток ответа не
  // открывают (свод IG_START_EVENTS, `opens24h`).
  const windowOpen = events === null || igEventsOpen24h(events);
  return [
    aboutStep(locale, { title: cfg.shortTitle?.(locale) ?? cfg.lead(locale).title }),
    accountStep(locale),
    entryStep(locale, cfg),
    // Шаг «Какое сообщение» ушёл у обеих анкет (ТЗ 02.09 §4, §5): слова каждого триггера
    // спрашиваются прямо на шаге «Что запускает».
    ...messageSteps(locale, events),
    ...(hasComment ? [commentsStep(locale, replyRow)] : []),
    additionalStep(locale, windowOpen),
  ];
}

/**
 * АНКЕТА ИНСТАГРАМА ЦЕЛИКОМ. Настройка запуска приходит cfg, всё остальное — общее.
 */
export function makeIgWizard(cfg: IgWizardCfg): TemplateWizardDef {
  const read = (a: Record<string, unknown>, locale: WizardLocale) => readIgAnswers(a, locale, cfg);
  return {
    id: cfg.id,
    // Заготовка «Сообщения» подарка под вид материала (владелец 20.09.2026) — те же
    // слова, что у телеграм-сестры (GIFT_TEXTS), ссылка — своим текстом этой анкеты.
    kindTexts: [
      {
        select: WIZ_GIFT_KIND,
        field: 'linkText',
        // Ссылка в Telegram-бот — та же ссылка кнопкой, заготовка та же.
        text: {
          ...GIFT_TEXTS,
          link: { ru: IG_TXT.ru.link, en: IG_TXT.en.link },
          [WIZ_GIFT_TG]: { ru: IG_TXT.ru.link, en: IG_TXT.en.link },
        },
      },
    ],
    // Фраза по галочке «Проверить подписку» (владелец 20.09.2026, механика ChatPlace):
    // включили — условие дописывается в приветствие, выключили — убирается (core.ts).
    toggleTexts: [
      // «Дополнительное сообщение» включили, а поле пустое — пример (ТЗ USERTEST-1014 п.8).
      EXTRA_TEXT_TOGGLE,
      {
        toggle: 'checkSub',
        field: 'welcomeText',
        text: {
          ru: 'Чтобы получить материал, подпишись на аккаунт и нажми кнопку.',
          en: 'To get the material, follow the account and tap the button.',
        },
      },
    ],
    templateSource: cfg.templateSource,
    // СЕМЕЙСТВА НЕТ (владелец 2026-08-06, Ш2: «разъедини телеграм от инстаграма»):
    // анкета инстаграмная, в ней только инста-аккаунты и один значок сети.
    // Аккаунт — первым вопросом (Ф2, копия ChatPlace); варианты подставляет панель,
    // выбранный аккаунт сервер проставляет в узлы канона при создании и пересборке.
    accountChannel: 'instagram',
    demoScene: cfg.demoScene,
    lead: cfg.lead,

    // ПОЛНЫЙ набор шагов: из него берутся умолчания полей (`wizardDefaults`) и число
    // шагов в шапке до первого ответа. Что человек увидит на самом деле, решает
    // `dynamicSteps` ниже — по его триггерам.
    steps(locale: WizardLocale) {
      return igSteps(locale, cfg, cfg.fixedEvents ?? null);
    },

    // ШАГИ ПРИ ТЕКУЩИХ ОТВЕТАХ (К18.3 этап 2 п.4): публичный ответ под комментарием и
    // напоминание с задержкой зависят от ТРИГГЕРОВ, а триггеры теперь список `entries` —
    // прежним условием показа по галочкам `entryEvents` их не выразить.
    dynamicSteps(answers, locale) {
      const a = readIgAnswers(answers, locale, cfg);
      // СТРОКА «ОТВЕЧАТЬ В КОММЕНТАРИЯХ» — ПРИ ВХОДЕ «ЛЮБОЙ КОММЕНТАРИЙ» (§18.0 п.5): она
      // и есть выключатель, поэтому стоит и при выключенном ответе. При входе со словом
      // шаг прежний (тумблер и варианты).
      return igSteps(locale, cfg, cfg.fixedEvents ?? a.events, (a.entry.comment?.kind ?? 'any') === 'any');
    },

    // Вид «Комментарий» превью: что человек пишет под публикацией и что бот отвечает
    // ПУБЛИЧНО (Э3.3 — фраза берётся случайной; в превью показываем по порядку).
    previewComments(answers, locale) {
      const a = read(answers, locale);
      if (!a.events.includes('comment')) return null;
      const ru = locale === 'ru';
      const word = entryWord(a, 'comment');
      const user = word || (ru ? 'Хочу!' : 'Want it!');
      const replies = a.commentReply && a.commentTexts.length > 0 ? a.commentTexts : [];
      const inDm = ru ? 'Ответили в личных сообщениях' : 'Replied in direct messages';
      if (replies.length === 0) {
        return [{ user, bot: inDm }];
      }
      // ПУБЛИЧНО — ТОЛЬКО ПОД КОММЕНТАРИЕМ СО СЛОВОМ (Л5.2.2 п.5): в превью это видно
      // двумя парами — со словом бот отвечает под комментарием, без слова уходит только
      // личное сообщение. Так человек видит отбор до запуска, а не после жалобы.
      const filterWord = a.commentReplyMode !== 'all' ? (a.commentReplyWords[0] ?? '') : '';
      if (filterWord !== '') {
        return [
          { user: filterWord, bot: replies[0]! },
          { user: ru ? 'Классный пост' : 'Great post', bot: inDm },
        ];
      }
      return replies.slice(0, 3).map((bot) => ({ user, bot }));
    },

    // ФРАЗЫ ЭТОГО БОТА В ТЕЛЕФОНЕ ПЕРВОГО ЭКРАНА (ТЗ-7 Ш3): подставляются все места
    // сцены, которые в анкете есть; чего нет — остаётся текст сцены. Текста поста
    // человек не пишет — в нём меняется само кодовое слово (lib/wizard-scene-texts).
    sceneTexts(answers, locale) {
      const a = read(answers, locale);
      const out: SceneTexts = {};
      const word = entryWord(a, a.events.includes('comment') ? 'comment' : undefined);
      if (word) out.comment = word;
      if (a.events.includes('comment') && a.commentReply && a.commentTexts[0]) out.pub = a.commentTexts[0];
      if (a.welcomeText) out.reply = a.welcomeText;
      if (a.welcomeBtn) out.chip = a.welcomeBtn;
      if (a.linkText) out.give = a.linkText;
      // ПОДАРОК ССЫЛКОЙ (Д7, владелец 03.09.2026): вложения у бота нет, значит и карточки
      // файла в примере быть не должно — метка выбрасывает этот шаг из копии сцены.
      // Раньше слот оставался пустым, и на экран возвращалось имя подарка НИШИ («План
      // тренировок.pdf»), которого бот не шлёт.
      const file = wizFileName(a.gift.file);
      out.file = file || SCENE_NO_FILE;
      return out;
    },

    preview(answers, stepIdx, locale) {
      const a = read(answers, locale);
      const ru = locale === 'ru';
      const T = IG_TXT[locale];
      const userStart = entryWord(a) || (ru ? 'Привет!' : 'Hi!');
      // Индексы шагов: 0 — «О боте», 1 — аккаунт (19.09.2026).
      if (stepIdx <= 1) {
        if (!userStart) {
          return [
            {
              from: 'bot',
              text: ru
                ? 'Здесь показано, как чат-бот общается с клиентом'
                : 'This shows how the bot talks to a client',
            },
          ];
        }
        return [{ from: 'user', text: userStart }];
      }
      const msgs: WizardPreviewMsg[] = [];
      if (userStart) msgs.push({ from: 'user', text: userStart });
      msgs.push({
        from: 'bot',
        text: a.welcomeText,
        buttons: [a.welcomeBtn],
        ...(a.welcomeImage ? { imageUrl: a.welcomeImage } : {}),
      });
      msgs.push({ from: 'user', text: a.welcomeBtn });
      // С проверкой подписки превью показывает и дожим: нажал кнопку без подписки →
      // «Если нет подписки» → подписался, нажал повторную проверку → выдача.
      if (a.checkSub) {
        msgs.push({ from: 'bot', text: a.noSubText, buttons: [a.noSubBtn] });
        msgs.push({ from: 'user', text: a.noSubBtn });
      }
      // Ссылка — кнопкой «Открыть» внутри сообщения (Э2.1), как соберёт buildWorkflow.
      // Вложение уходит ОТДЕЛЬНЫМ сообщением — так его и рисуем (в теле запроса Меты
      // либо текст, либо файл).
      if (a.gift.kind === WIZ_GIFT_LINK) {
        msgs.push(
          a.linkUrl
            ? { from: 'bot', text: a.linkText, buttons: [a.linkBtn] }
            : { from: 'bot', text: `${a.linkText}\n\n${T.linkStub}` },
        );
      } else {
        msgs.push({ from: 'bot', text: a.linkText });
        msgs.push({ from: 'bot', text: '', attach: { kind: a.gift.kind, url: a.gift.file } });
      }
      if (stepIdx >= 3) {
        if (a.remind) msgs.push({ from: 'bot', text: a.remindText, buttons: [a.welcomeBtn] });
        if (ansBool(answers, 'extra')) msgs.push({ from: 'bot', text: a.extraText || T.nExtra });
      }
      return msgs;
    },

    buildWorkflow(template, answers, locale) {
      return buildIgWorkflow(template, read(answers, locale), locale);
    },

    // ВХОДЫ БОТА (§3.2): ровно то, что человек отметил, по элементу на вход. Подписи
    // кнопок сюда НЕ попадают — их добавляет синк маршрутов сам (§3.5).
    //
    // ЗАМОК ДИАЛОГА — НЕ ВЫБОР, А ЗАКОН (владелец 08.09.2026, Л1 п.5; прежде включался
    // только с проверкой подписки). Пока человек внутри бота, ВСЁ его входящее идёт
    // этому боту: чужое слово, «любое», кнопки, «/start». Отпускает его конец сценария
    // или молчание дольше срока из анкеты (`finishHours` → `holdTimeoutMin`, минуты).
    triggerMeta(answers, locale) {
      const a = read(answers, locale);
      return {
        entries: entriesOf(a),
        holdDialog: true,
        holdTimeoutMin: a.finishHours * 60,
        // «Не запускать повторно» (владелец 09.09.2026, Л5.1 п.1): дни анкеты — минуты
        // черновика; выключено — ровно 0, иначе прежний запрет остался бы жить.
        antiRepeatMin: a.noRepeat ? a.noRepeatDays * 1440 : 0,
      };
    },

    // Запуски для предохранителя от копий: только то, что человек ВЫБРАЛ (см. core.ts).
    duplicateStarts(answers, locale) {
      return entriesOf(read(answers, locale));
    },

    stepBlocked(answers, stepKey, locale) {
      if (stepKey !== 'entry') return null;
      // ВХОД ЖЁСТКИЙ — на шаге обычная форма: проверяем только «Только под выбранными»
      // без единой публикации (сценарий молча слушал бы ВСЁ).
      if (cfg.fixedEvents) {
        const a = read(answers, locale);
        return a.events.includes('comment') && a.postsMode === 'some' && a.mediaIds.length === 0
          ? trigWords(locale).needPosts
          : null;
      }
      // СПИСОК ТРИГГЕРОВ: ни одного — бот не запустится никогда; половинчатый (слова
      // обещаны, а не вписаны) в базу не уедет. Слова блокировки — ОБЩИЕ (К18.1 п.9).
      const list = igStore.read(answers);
      if (list.length === 0) return wizEntryWords(locale).empty;
      return trigBlocked('ig', locale, list, answers);
    },
  };
}
